export type CentralCaseIdentity = {
  id: string;
};

export type CentralCaseContextReason =
  | "selected"
  | "selection_required"
  | "requested_case_unavailable"
  | "no_cases";

export type CentralCaseContextResolution = {
  reason: CentralCaseContextReason;
  selectedCaseId: string;
};

/**
 * Resolves only explicit Central case identity. Record order is deliberately
 * irrelevant: consequential work must never inherit the first query result.
 */
export function resolveCentralCaseContext(
  cases: readonly CentralCaseIdentity[],
  requestedCaseId: string,
  _currentCaseId = "",
): CentralCaseContextResolution {
  if (!cases.length) {
    return { reason: "no_cases", selectedCaseId: "" };
  }

  if (requestedCaseId) {
    return cases.some((record) => record.id === requestedCaseId)
      ? { reason: "selected", selectedCaseId: requestedCaseId }
      : { reason: "requested_case_unavailable", selectedCaseId: "" };
  }

  return { reason: "selection_required", selectedCaseId: "" };
}

export type CentralCaseRequestToken = {
  requestedCaseId: string;
  sequence: number;
};

export function isCentralCaseRequestCurrent(
  request: CentralCaseRequestToken,
  currentSequence: number,
  currentRequestedCaseId: string,
) {
  return request.sequence === currentSequence
    && request.requestedCaseId === currentRequestedCaseId;
}

export function canMutateCentralCase(loadedCaseId: string, requestedCaseId: string) {
  return Boolean(loadedCaseId && requestedCaseId && loadedCaseId === requestedCaseId);
}

export function buildCentralCaseWorkspacePath(screenId: string, caseId: string) {
  const base = `/workspace/${screenId}`;
  return caseId ? `${base}?caseId=${encodeURIComponent(caseId)}` : base;
}
